module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/4-432b3f64cdf2d0255f0289b537a08706.png";